@if ((showMobileShoppingCart$ | async) === false) {
} @else {
  <section class="back-nav">
    @if (showBackButton$ | async) {
      <button class="borderless back-btn" (click)="back()">
        <i class="fa-kit fa-arrow-left-yh"></i>
      </button>
    } @else {
      <span></span>
    }
  </section>
}
@if ((homePage$ | async) === true || (isBookingPage$ | async) === true) {
  <section class="second-header"
    [class.fix-height]="showGreeting"
    >
    @if (isWebView === false) {
      <div class="blue"></div>
    }
    @if (showGreeting) {
      <div class="float">
        <div class="page-size">
          <h1 class="greeting">
            @if (isBookingPage$ | async) {
              @if (showLabelFromProgressbar()) {
                <span class="greeting-1">{{ showLabelFromProgressbar() | translate }}</span>
              } @else {
                <span class="greeting-1">{{ 'bookingBarTitle' | translate }}</span>
              }
            } @else {
              @if (loggedIn) {
                <span class="greeting-1">{{ 'greeting' | translate }} {{ name$ | async }}.</span>
                <span class="greeting-2">{{ 'welcomeToGuestPortal' | translate }}</span>
              } @else {
                <span class="greeting-1">{{ 'greeting' | translate }}.</span>
                <span class="greeting-2">{{ 'welcomeToGuestPortal' | translate }}</span>
              }
            }
          </h1>
          <!-- <app-shopping-cart-dropdown *ngIf="(isMobile$ | async) === false"></app-shopping-cart-dropdown> -->
        </div>
      </div>
    }
  </section>
} @else {
  <section class="back-nav">
    @if (showBackButton$ | async) {
      <button class="borderless back-btn" (click)="back()">
        <i class="fa-kit fa-arrow-left-yh"></i>
      </button>
    } @else {
      <span></span>
    }
  </section>
}

